/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class CrmService implements ICrmService {
    public static $inject = [];

    constructor() {}

    // TODO: this is a test function that returns hard-coded data from the service. Must be replaced with real calls.
    public getCrmOrgList(): any {
        let testOrgList: any = [
            {
                orgName: 'Org1',
                orgId: '12346896488315223',
                matches: [
                    {
                        crmMatchName: 'match1',
                        crmMatchLink: 'www.example.com/match1link' // link to spiro
                    },
                    {
                        crmMatchName: 'match2',
                        crmMatchLink: 'www.example.com/match2link' // link to spiro
                    }
                ],
                getOrgPreview: {
                    orgIndustry: 'sdf',
                    orgWebUrl: 'www.theexample.com',
                    hrmPhoneNum: '0126354321',
                    hrmEmail: 'email@sdf.dsc.as',
                    hrmName: 'Sheldon Cooper'
                }
            },
            {
                orgName: 'Org2',
                orgId: 'VBNMDFG46896488315FG3',
                matches: [
                    {
                        crmMatchName: 'sdf',
                        crmMatchLink: 'www.example.com/sdflink' // link to spiro
                    },
                    {
                        crmMatchName: 'werwer',
                        crmMatchLink: 'www.example.com/werwerlink' // link to spiro
                    }
                ],
                getOrgPreview: {
                    orgIndustry: 'asdf',
                    orgWebUrl: 'www.theexample.com',
                    hrmPhoneNum: '0126354321',
                    hrmEmail: 'email@sdf.dsc.as',
                    hrmName: 'Lennerd Hofstadter'
                }
            },
            {
                orgName: 'Org3',
                orgId: 'SADF46896488315DST3',
                matches: [
                    {
                        crmMatchName: 'sdfsdsg',
                        crmMatchLink: 'www.example.com/sdfsdsglink' // link to spiro
                    }
                ],
                getOrgPreview: {
                    orgIndustry: 'mining',
                    orgWebUrl: 'www.theexample.com',
                    hrmPhoneNum: '0126354321',
                    hrmEmail: 'email@sdf.dsc.as',
                    hrmName: 'Howard Wolowitz '
                }
            }
        ];
        
        return testOrgList;
    }

    // TODO: this is a test function that returns hard-coded data from the service. Must be replaced with real calls.
    public getOrgPreview (orgId: any): any {
        // get the org data for that ID here
    }

    // TODO: this is a test function that returns hard-coded data from the service. Must be replaced with real calls.
    public acceptReview(orgId: any, crmLink: any): void {
        // this will accept the orgData that has been loaded from the list and then remove it from the review list,
    }

    // TODO: this is a test function that returns hard-coded data from the service. Must be replaced with real calls.
    public rejectReview(orgId: any, crmLink: any): void {
        // this will send the crm link that is displayed for that match to be rejected
        // then it will need to remove this orgItem from the review list and reload data for the list
    }
}

angular.module('beneple.global')
    .service('CrmService', CrmService);



// WEBPACK FOOTER //
// ./frontend/scripts/admin/services/crm.service.ts